import React, { useState } from "react"
import MetaTags from "react-meta-tags"
import {
  Col,
  Container,
  Row,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

import ServiceStructure from "../../components/Services/structure/ServiceStructure"

const NominationLetter = () => {
  const [menu, setMenu] = useState(false)
  const toggle = () => {
    setMenu(!menu)
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Letter of Nomination | REMA</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={12}>
                <h6 className="page-title">
                  Request for accreditation to the GCF
                </h6>

                <ServiceStructure
                  disablePayableFee={true}
                  disableLicenseValidity={true}
                  detailsType="accreditation"
                  url="nomination-letter-accreditation-apply"
                  serviceType="Request for accreditation to the GCF"
                  department="Advocacy & Multilateral Environment Agreement Monitoring Unit (AMEAMU)"
                />
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default NominationLetter
